/* ================================================================
   Hope Estate — More Info Modal
   Intercepts "More Info" / "Choose options" card buttons
   and shows a Full Case vs Mix & Match chooser.
   ================================================================ */
(function() {
  'use strict';

  /* Config: map collection handles / product types to modal options */
  var MODAL_CONFIG = {
    beer: {
      eyebrow: 'Hope Brewery',
      prompt: 'How would you like to shop our beers?',
      options: [
        {
          type: 'fullcase',
          title: 'Full Case',
          desc: 'Buy a full case of your chosen beer.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>',
          href: null  // goes to product page
        },
        {
          type: 'mixmatch',
          title: 'Mix & Match',
          desc: 'Build your own custom pack.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>',
          primary: true,
          subopts: [
            { label: 'Build 12PK', href: '/pages/mix-match-beer' },
            { label: 'Build 24PK', href: '/pages/mix-match-beer' }
          ]
        }
      ]
    },
    wine: {
      eyebrow: 'Hope Estate',
      prompt: 'How would you like to shop our wines?',
      options: [
        {
          type: 'fullcase',
          title: 'Full Case',
          desc: 'Buy a full case of your chosen wine.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 22h8M12 11v11M6.5 6.5 5 3h14l-1.5 3.5C16 9 14.5 11 12 11S8 9 6.5 6.5z"/></svg>',
          href: null
        },
        {
          type: 'mixmatch',
          title: 'Mix & Match',
          desc: 'Build your own custom pack.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>',
          primary: true,
          subopts: [
            { label: 'Build 6PK', href: '/pages/mix-match-wine' },
            { label: 'Build 12PK', href: '/pages/mix-match-wine' }
          ]
        }
      ]
    },
    spirits: {
      eyebrow: 'Hope Distillery',
      prompt: 'How would you like to shop our spirits?',
      options: [
        {
          type: 'fullcase',
          title: 'Buy a Bottle',
          desc: 'Purchase an individual bottle from our spirits range.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 22h8M12 11v11M6.5 6.5 5 3h14l-1.5 3.5C16 9 14.5 11 12 11S8 9 6.5 6.5z"/></svg>',
          href: null
        },
        {
          type: 'mixmatch',
          title: 'Mix and Match',
          desc: 'Build your own custom spirits pack.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>',
          primary: true,
          href: '/pages/mix-match-spirits'
        }
      ]
    }
  };

  /* Detect category from collection URL or product type tag */
  function detectCategory(btn) {
    var url = window.location.pathname;
    var card = btn.closest('.card-wrapper');
    var type = (card && card.dataset.productType) ? card.dataset.productType.toLowerCase() : '';
    var tags = (card && card.dataset.productTags) ? card.dataset.productTags.toLowerCase() : '';
    var title = (card && card.dataset.productTitle) ? card.dataset.productTitle.toLowerCase() : '';
    var combined = url + ' ' + type + ' ' + tags + ' ' + title;

    if (/beer|brew|ipa|stout|ale|lager|cider|pale|sour|hazy|neipa|iiipa/i.test(combined)) return 'beer';
    if (/wine|shiraz|chardonnay|semillon|riesling|rose|ros|pinot|merlot|cabernet|sauvignon|verdelho|tempranillo/i.test(combined)) return 'wine';
    if (/spirit|gin|vodka|whisky|whiskey|distill|moonshine|liqueur/i.test(combined)) return 'spirits';

    // Fallback: check the collection path segments
    if (url.indexOf('/collections/') !== -1) {
      var seg = url.split('/collections/')[1] || '';
      if (/beer|full-beer|brew/i.test(seg)) return 'beer';
      if (/wine|full-wine/i.test(seg)) return 'wine';
      if (/spirit|gin|vodka|whiskey|full-spirits/i.test(seg)) return 'spirits';
    }

    // For /collections/all or unknown pages — detect from product title on card
    var heading = card ? card.querySelector('.card__heading a, .card__heading') : null;
    var headingText = heading ? heading.textContent.toLowerCase() : '';
    if (/beer|ipa|ale|stout|sour|lager|cider|hazy|pale/i.test(headingText)) return 'beer';
    if (/wine|shiraz|chardonnay|riesling|semillon|pinot|cab|rose/i.test(headingText)) return 'wine';
    if (/gin|vodka|whiskey|whisky|spirit|moonshine/i.test(headingText)) return 'spirits';

    // Last resort: return beer as default for any undetected product
    // (most products on this store are beer)
    return 'beer';
  }

  /* Get product name from the card */
  function getProductName(btn) {
    var card = btn.closest('.card-wrapper, .card__content, li');
    if (!card) return '';
    var heading = card.querySelector('.card__heading a, .card__heading');
    return heading ? heading.textContent.trim() : '';
  }

  /* Detect whiskey within the spirits category.
     Whiskey keeps "Buy a Bottle"; gin / vodka / moonshine / other spirits become "Buy 6". */
  function isWhiskey(btn, productName) {
    var url = window.location.pathname.toLowerCase();
    var card = btn.closest('.card-wrapper, li');
    var ds = (card && card.dataset) ? card.dataset : {};
    var type = (ds.productType || '').toLowerCase();
    var tags = (ds.productTags || '').toLowerCase();
    var title = (ds.productTitle || '').toLowerCase();
    var name = (productName || '').toLowerCase();
    // On a product page, also read the on-page product heading.
    var h1 = document.querySelector('.product__title, .product-title, h1');
    var heading = h1 ? h1.textContent.toLowerCase() : '';
    var combined = url + ' ' + type + ' ' + tags + ' ' + title + ' ' + name + ' ' + heading;
    return /whisk(e)?y|bourbon|scotch|single\s*malt|\brye\b/i.test(combined);
  }

  /* Build modal HTML */
  function buildModal(config, productName, productHref) {
    var isSingle = config.options.length === 1;
    var optsHtml = config.options.map(function(opt) {
      var cls = 'he-modal__opt' + (opt.primary ? ' he-modal__opt--primary' : '');
      var href = (opt.type === 'fullcase' && productHref) ? productHref : (opt.href || '#');
      var subHtml = '';
      if (opt.subopts) {
        subHtml = '<div class="he-modal__subopts">' + opt.subopts.map(function(s) {
          return '<a href="' + s.href + '" class="he-modal__subopt">' + s.label + '</a>';
        }).join('') + '</div>';
        return '<div class="' + cls + '" style="cursor:default;">' +
          '<div class="he-modal__opt-icon">' + opt.icon + '</div>' +
          '<div class="he-modal__opt-title">' + opt.title + '</div>' +
          '<div class="he-modal__opt-desc">' + opt.desc + '</div>' +
          subHtml + '</div>';
      }
      return '<a href="' + href + '" class="' + cls + '">' +
        '<div class="he-modal__opt-icon">' + opt.icon + '</div>' +
        '<div class="he-modal__opt-title">' + opt.title + '</div>' +
        '<div class="he-modal__opt-desc">' + opt.desc + '</div>' +
        '</a>';
    }).join('');

    return '<div class="he-modal" role="dialog" aria-modal="true">' +
      '<button class="he-modal__close" aria-label="Close">&times;</button>' +
      '<div class="he-modal__header">' +
        '<p class="he-modal__eyebrow">' + config.eyebrow + '</p>' +
        '<h2 class="he-modal__product-name">' + (productName || 'Choose your option') + '</h2>' +
      '</div>' +
      '<div class="he-modal__body">' +
        '<p class="he-modal__prompt">' + config.prompt + '</p>' +
        '<div class="he-modal__options' + (isSingle ? ' he-modal__options--single' : '') + '">' +
          optsHtml +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* Create overlay once */
  var overlay = document.createElement('div');
  overlay.className = 'he-modal-overlay';
  overlay.setAttribute('role', 'presentation');
  document.body.appendChild(overlay);

  function openModal(html) {
    overlay.innerHTML = html;
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Close any open Dawn quick-add modals
    document.querySelectorAll('details[open]').forEach(function(d) {
      if (d.closest('.quick-add')) d.removeAttribute('open');
    });
    document.querySelectorAll('.quick-add__modal-overlay').forEach(function(el) {
      el.click();
    });
    // Focus close button
    var closeBtn = overlay.querySelector('.he-modal__close');
    if (closeBtn) closeBtn.focus();
    // Bind close
    closeBtn && closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    // ESC key
    document.addEventListener('keydown', handleEsc);
  }

  function closeModal() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleEsc);
  }

  function handleEsc(e) { if (e.key === 'Escape') closeModal(); }

  /* Intercept More Info / Choose Options buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quick-add__submit, .card__footer .button, [data-he-moreinfo]');
    if (!btn) return;

    var cat = detectCategory(btn);
    if (!cat) return; // not a categorised product — let default behaviour happen

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var config = MODAL_CONFIG[cat];
    if (!config) return;

    var productName = getProductName(btn);

    // Spirits that are NOT whiskey: relabel "Buy a Bottle" -> "Buy 6".
    // Whiskey (gin/vodka/moonshine excluded) keeps the original label.
    if (cat === 'spirits' && !isWhiskey(btn, productName)) {
      config = JSON.parse(JSON.stringify(config)); // clone so the shared config (and whiskey) stays untouched
      config.options.forEach(function(opt) {
        if (opt.type === 'fullcase') {
          opt.title = 'Buy 6';
          opt.desc = 'Purchase a 6-pack from our spirits range.';
        }
      });
    }

    // Get product href from card heading link
    var card = btn.closest('.card-wrapper, li');
    var link = card && card.querySelector('.card__heading a');
    var productHref = link ? link.getAttribute('href') : null;

    openModal(buildModal(config, productName, productHref));
  });
})();
